import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function DistributionQuoteModal({ show, setShow }) {
	const navigate = useNavigate();
	const [contractNumber, setContractNumber] = useState("");

	const handleClose = () => {
		setShow(false);
	};

	const handleSubmit = async (event) => {
		navigate(`/contracts/${contractNumber}/disbursement-quote-request`);
	};

	const handleChange = (event) => {
		setContractNumber(event.target.value);
	};

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Enter Contract Number</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={handleSubmit}>
					<Form.Group controlId="contractNumber">
						<Row>
							<Col xs={4}>
								<Form.Label>Contract Number</Form.Label>
							</Col>
							<Col xs={7} className="text-start me-auto">
								<Form.Control
									type="text"
									placeholder="Enter contract number"
									value={contractNumber}
									onChange={handleChange}
								/>
							</Col>
						</Row>
					</Form.Group>
					<Row>
            <Col xs={11}>
						<Button variant="primary" type="submit" className="mt-2 float-end" disabled={contractNumber === ""}>
							Submit
						</Button>
            </Col>
					</Row>
				</Form>
			</Modal.Body>
		</Modal>
	);
}

export default DistributionQuoteModal;
